import { render, staticRenderFns } from "./pointPosition.vue?vue&type=template&id=cc67d93a&scoped=true"
import script from "./pointPosition.vue?vue&type=script&lang=js"
export * from "./pointPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc67d93a",
  null
  
)

export default component.exports